import { csvCellGuard } from "@talentkontor/domain";

/**
 * CSV für Excel: Semikolon, CRLF, UTF-8 mit BOM, Felder mit Trennzeichen in Anführungszeichen und Schutz gegen Formeln in
 * jeder Zelle, die keine reine Zahl ist (csvCellGuard; Gegenprüfung GB-D2/GB-W3/GB-W4). Beträge wie „-12,50“ bleiben Zahlen.
 */
export function excelCsv(rows: readonly (readonly (string | number | null | undefined)[])[], opts: { trailingNewline?: boolean } = {}): string {
  const cell = (v: string | number | null | undefined) => {
    const s = csvCellGuard(v === null || v === undefined ? "" : String(v));
    return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return "\uFEFF" + rows.map((r) => r.map(cell).join(";")).join("\r\n") + (opts.trailingNewline ? "\r\n" : "");
}
